import DispatchConstants from '../../constants/DispatchConstants';
import { REVIEW_PAGE_SECTION_RECS } from '../../constants/RecommendationsConstants';

const {
  AMENITIES,
  MEDIA,
  RENT_DETAILS,
  CONTACT,
  PROPERTY_INFORMATION,
  BUILDING_DETAILS,
  FLOOR_PLANS,
  KEY_FEATURES,
  SPECIAL_OFFERS,
  OTHER_PROPERTY_FEATURES,
  POLICIES_AND_TERMS,
  COSTS_AND_FEES,
  SCREENING_CRITERIA,
} = REVIEW_PAGE_SECTION_RECS;

const initState = () => ({
  isEnabled: false,
  recommendations: [],
  recommendationsByType: {},
  // SF
  [RENT_DETAILS]: {},
  [AMENITIES]: {},
  [SCREENING_CRITERIA]: {},
  // MF
  [PROPERTY_INFORMATION]: {},
  [BUILDING_DETAILS]: {},
  [CONTACT]: {},
  [FLOOR_PLANS]: {},
  [SPECIAL_OFFERS]: {},
  [KEY_FEATURES]: {},
  [OTHER_PROPERTY_FEATURES]: {},
  [POLICIES_AND_TERMS]: {},
  // SF and MF
  [CONTACT]: {},
  [MEDIA]: {},
  [COSTS_AND_FEES]: {},
});

const recommendations = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_RECOMMENDATIONS: {
      return {
        ...payload,
      };
    }

    default:
      return state;
  }
};

export default recommendations;
